import { Select } from "../../../../utils/form";

const Title = ({ form: { control } }) =>
  <Select control={control} name="title" label="Título" list={["Dr", "Dra"]} variant="outlined" required style={{ width: "100%" }} />

export default Title;